import ContactPhoneNumbers from './contact_phone_numbers'
import ProgramPhoneNumbers from './program_phone_numbers'
import Container from '@admin/components/container'
import Message from '@admin/components/message'
import Stack from '@admin/components/stack'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.PureComponent {

  static contextTypes = {
    modal: PropTypes.object,
    twilio: PropTypes.object
  }

  static propTypes = {
    program_phone_numbers: PropTypes.array,
    contact: PropTypes.object
  }

  stackRef = React.createRef()

  state = {
    contact_phone_number: null,
    program_phone_number: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleContactPhoneNumber = this._handleContactPhoneNumber.bind(this)
  _handlePop = this._handlePop.bind(this)
  _handleProgramPhoneNumber = this._handleProgramPhoneNumber.bind(this)
  _handlePush = this._handlePush.bind(this)

  render() {
    const { program_phone_numbers } = this.props
    return program_phone_numbers.length === 0 ?
      <Message { ...this._getMessage() } /> :
      <Stack { ...this._getStack() } />
  }

  componentDidMount() {
    const { program_phone_numbers } = this.props
    if(program_phone_numbers.length === 1) {
      this._handleProgramPhoneNumber(program_phone_numbers[0])
    } else {
      this._handlePush(ProgramPhoneNumbers, this._getProgramPhoneNumbers())
    }
  }

  _getMessage() {
    return {
      svg: 'phone',
      title: 't(No Phone Numbers)',
      text: 't(You have not provisioned any phone numbers)'
    }
  }

  _getContactPhoneNumbers() {
    const { contact, program_phone_numbers } = this.props
    return {
      program_phone_numbers,
      contact_phone_numbers: contact.phone_numbers,
      onBack: this._handlePop,
      onCancel: this._handleCancel,
      onChoose: this._handleContactPhoneNumber
    }
  }

  _getProgramPhoneNumbers() {
    const { program_phone_numbers } = this.props
    return {
      program_phone_numbers,
      onCancel: this._handleCancel,
      onChoose: this._handleProgramPhoneNumber
    }
  }

  _getStack() {
    return {
      display_name: 'calls',
      ref: this.stackRef
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handleProgramPhoneNumber(program_phone_number) {
    const { contact } = this.props
    this.setState({ program_phone_number }, () => {
      if(contact.phone_numbers.length === 1) {
        return this._handleContactPhoneNumber(contact.phone_numbers[0])
      }
      this._handlePush(ContactPhoneNumbers, this._getContactPhoneNumbers())
    })
  }

  _handleContactPhoneNumber(contact_phone_number) {
    const { program_phone_number } = this.state
    const { contact } = this.props
    this.context.modal.close()
    this.context.twilio.call({
      phone_number: program_phone_number,
      program: program_phone_number.program,
      number: contact_phone_number.number,
      contact,
      device: 'maha'
    })
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

}

const mapResources = (props, context) => ({
  program_phone_numbers: {
    endpoint: '/api/admin/phone/numbers',
    filter: {
      released_at: {
        $nl: true
      }
    }
  }
})

export default Container(mapResources)(New)
